import React, { useContext } from 'react';
import Head from 'next/head';
import { CoreContext } from './context/index.js';

const NextHead = ({ meta, content, siteUrl }) => {
    const { data: { siteConfig: { siteName, googleSiteVerification, defaultOgImage }, }, } = useContext(CoreContext);
    let ogImage = null;
    if (meta.image) {
        ogImage = meta.image;
    }
    else if (siteUrl) {
        ogImage = `${siteUrl}${defaultOgImage}`;
    }
    return (React.createElement(Head, null,
        React.createElement("meta", { name: "format-detection", content: "telephone=no" }),
        googleSiteVerification && (React.createElement("meta", { name: "google-site-verification", content: googleSiteVerification })),
        React.createElement("title", null, meta.title),
        React.createElement("meta", { name: "description", content: meta.description }),
        meta.keyword && React.createElement("meta", { name: "keywords", content: meta.keyword }),
        React.createElement("meta", { property: "og:type", content: "website" }),
        siteName && React.createElement("meta", { property: "og:site_name", content: siteName }),
        React.createElement("meta", { property: "og:title", content: meta.title }),
        React.createElement("meta", { property: "og:description", content: meta.description }),
        ogImage && React.createElement("meta", { property: "og:image", content: ogImage }),
        meta.url && React.createElement("meta", { property: "og:url", content: meta.url }),
        content));
};

export { NextHead as N };
//# sourceMappingURL=NextHead-828BS7ON.js.map
